import React from 'react';
import './style.scss';
import emptyMixer from "../../../assets/img/mixer/empty_mixer.png"

const EmptyMixer = () => (
    <div className="empty-mixer">
        <div className="empty-mixer__container">
            <img
                className="empty-mixer__img"
                src={emptyMixer}
                alt="mixer"
            />
            <div className="empty-mixer__title">
                Сейчас в миксере пусто. Чтобы найти миксы, добавьте в миксер вкусы из каталога
            </div>
        </div>
    </div>
);

export default EmptyMixer;
